import { createContext } from 'react';

const EditorIsReadonlyContext = createContext(false);

export default EditorIsReadonlyContext;
